import React, { Fragment, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../../contextStore/AuthContext';
import { ToastContext } from '../../contextStore/ToastContext';
import { Firebase, firebase } from '../../firebase/config';
import OverlaySpinner from '../Loading/OverlaySpinner';
import AdForm from './AdForm';
import './Create.css';
import { useCreateForm } from './useCreateForm';

const Create = () => {
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const history = useHistory();

  const {
    values,
    loading,
    setLoading,
    onChange,
    errors,
    setErrors,
  } = useCreateForm();

  // 🚀 DIRECT FIRESTORE PUBLISHING HANDLER
  const handleDirectPublish = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    if (!user) {
      addToast('Please log in to post a listing.', 'error');
      return;
    }

    // 🛡️ Field Validations
    const err = {};
    if (!values.category) err.category = 'Category is required.';
    if (!values.name?.trim()) err.name = 'Item title is required.';
    if (!values.price) err.price = 'Price is required.';
    if (!values.condition?.trim()) err.condition = 'Condition is required.';

    if (!values.pickupAddress || !values.pickupAddress.trim()) {
      err.pickupAddress = 'A complete pickup address is required for courier dispatch.';
    }
    if (!values.payoutMethod?.upiId || !values.payoutMethod.upiId.trim()) {
      err.payoutMethod = { upiId: 'Please provide a valid UPI address target.' };
    }

    if (Object.keys(err).length > 0) {
      setErrors(err);
      addToast('Please fix your form errors before posting.', 'error');
      return;
    }

    setLoading(true);

    try {
      const filesToUpload = values.images ? values.images.filter((i) => i instanceof File) : [];
      const existingUrls = values.images ? values.images.filter((i) => typeof i === 'string') : [];
      let uploadedUrls = [];

      if (filesToUpload.length > 0) {
        const uploadPromises = filesToUpload.map((file) =>
          Firebase.storage()
            .ref(`/image/${user.uid}_${Date.now()}_${file.name}`)
            .put(file)
            .then((snap) => snap.ref.getDownloadURL())
        );
        uploadedUrls = await Promise.all(uploadPromises);
      }

      const finalImagesArray = [...existingUrls, ...uploadedUrls];

      // 🎯 SECURE ESCROW PAYLOAD (Aligned perfectly with security rules)
      // 🎯 SECURE ESCROW PAYLOAD (Aligned perfectly with security rules)
const productPayload = {
  name: values.name,
  category: values.category,
  subcategory: values.subcategory || '',
  price: Number(values.price) || 0,
  priceCurrency: "INR",
  description: values.description || '',
  url: finalImagesArray[0] || '',
  images: finalImagesArray,
  userId: user.uid,
  condition: values.condition || '',
  createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  updatedAt: firebase.firestore.FieldValue.serverTimestamp(),

  // 🛡️ Rules-Required Fields
  status: 'pending',
  moderationStatus: 'pending',
  tags: [],

  // ⚡ Logistics & Settlement Mappings
  pickupAddress: values.pickupAddress,
  payoutMethod: values.payoutMethod,

  // 🔥 THE CRITICAL FIX: Explicitly bind the phone state value to the payload field name!
  sellerPhone: values.sellerPhone || '',

  location: values.location || {},
  extra: values.extra || {},
  negotiable: Boolean(values.negotiable)
};

      // 📥 Atomic execution statement directly into Firestore
      await Firebase.firestore().collection('products').add(productPayload);

      addToast('Marketplace listing created successfully!', 'success');
      history.push('/');
    } catch (dbError) {
      console.error("Direct Firestore insert failed:", dbError);
      addToast(`Submission failed: ${dbError.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleStubbedDraft = () => {
    addToast('Draft saving is currently bypassed.', 'info');
  };

  return (
    <Fragment>
      {loading && <OverlaySpinner />}
      <div className="createPageWrap">
        <div className="createPageActions">
          <Link to="/" className="createCancelLink">
            ← Cancel
          </Link>
        </div>

        <AdForm
          values={values}
          onChange={onChange}
          errors={errors}
          loading={loading}
          draftLoading={false}
          onSubmit={handleDirectPublish}
          submitLabel="Post ad"
          onSaveDraft={handleStubbedDraft}
        />
      </div>
    </Fragment>
  );
};

export default Create;
